import React, { memo } from 'react';

import { IThresholdTextTypes } from './ThresholdText.types';

import { EChartTypes } from '@enums/kpi-common';

import './ThresholdText.scss';

const ThresholdText = ({ chart, isVisible = true }: IThresholdTextTypes) => {
	const thresholds = chart.thresholds;
	const units = chart.type.name === EChartTypes.line ? '%' : '';

	return (
		<div className='f5gThresholdTextContainer'>
			{!!thresholds.length && isVisible
				&& <>
					{
						thresholds.length === 1
							? 'Threshold: ' + thresholds[0] + units
							: <>
								Min: {thresholds[0]}{units}
								&nbsp;&nbsp;&nbsp;
								Max: {thresholds[1]}{units}
							</>
					}
				</>
			}
		</div>
	);
};

export default memo(ThresholdText);
